import { motion } from 'motion/react';

const ScaleMotion = ({
  children,
  keyProp,
  className = '',
  disabled = false,
  duration = 0.25,
  scale = 1.05,
  scaleTap = 0.95,
}) => {
  return (
    <motion.div
      key={keyProp}
      whileHover={disabled ? false : { scale: scale }}
      whileTap={disabled ? false : { scale: scaleTap }}
      className={className}
      transition={{
        duration,
      }}>
      {children}
    </motion.div>
  );
};

export default ScaleMotion;
